import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.teensCheckbox = this.element.querySelector("#teens_field")
    this.adultsCheckbox = this.element.querySelector("#adults_field")
    this.adminsCheckbox = this.element.querySelector("#admin_only_field")
    this.studentProgramCheckboxes = [
      ...this.element.querySelectorAll('input[type="checkbox"]'),
    ].filter((checkbox) =>
      /^driving_schools_package\[student_program_id_\d+\]$/.test(checkbox.name)
    )

    this.boundTeensOrAdults = this.teensOrAdultsChanged.bind(this)
    this.boundAdmins = this.adminsChanged.bind(this)
    this.boundStudentProgramChanged = this.studentProgramChanged.bind(this)

    if (this.teensCheckbox) {
      this.teensCheckbox.addEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adultsCheckbox) {
      this.adultsCheckbox.addEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adminsCheckbox) {
      this.adminsCheckbox.addEventListener("change", this.boundAdmins)
    }
    this.studentProgramCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.boundStudentProgramChanged)
    })
  }

  disconnect() {
    if (this.teensCheckbox) {
      this.teensCheckbox.removeEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adultsCheckbox) {
      this.adultsCheckbox.removeEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adminsCheckbox) {
      this.adminsCheckbox.removeEventListener("change", this.boundAdmins)
    }
    this.studentProgramCheckboxes.forEach((checkbox) => {
      checkbox.removeEventListener("change", this.boundStudentProgramChanged)
    })
  }

  teensOrAdultsChanged(event) {
    if (event.target.checked && this.adminsCheckbox) {
      this.adminsCheckbox.checked = false
    }
  }

  adminsChanged(event) {
    if (event.target.checked) {
      if (this.teensCheckbox) {
        this.teensCheckbox.checked = false
      }
      if (this.adultsCheckbox) {
        this.adultsCheckbox.checked = false
      }
      this.studentProgramCheckboxes.forEach((checkbox) => {
        checkbox.checked = false
      })
    }
  }

  studentProgramChanged(event) {
    if (event.target.checked && this.adminsCheckbox) {
      this.adminsCheckbox.checked = false
    }
  }
}
